import { NetbankingAPI } from "aaa";
import * as _ from "lodash";
import { action, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { ICardFeeResult, IFee } from "types/fee";

export class FeesStore {
    @observable isLoading: boolean = false;
    @observable fees?: ICardFeeResult;

    @action async load(cardId: string, usableFor?: string) {
        this.isLoading = true;

        try {
            const target = NetbankingAPI.getFeesOfCard(cardId, usableFor);
            this.fees = await NetbankingAPIClient.requestType(target);

            this.isLoading = false;
        } catch (err) {
            this.isLoading = false;
            throw err;
        }
    }

    getFeeForType(feeType: string): IFee | undefined {
        if (!this.fees) {
            return;
        }

        const found = _.find(this.fees.fees, fee => {
            return fee.feeType === feeType;
        });

        return found;
    }
}



// WEBPACK FOOTER //
// ./src/stores/FeesStore.ts